import { useState } from 'react';
import { businessLogoUrl } from '../lib/images.ts';
import { cx } from '../ui/index.tsx';

/**
 * Logo del negocio; si no tiene (o no se puede cargar, por ejemplo sin conexión la primera vez),
 * la inicial del nombre con el color del negocio. El tamaño y el redondeo los pone className.
 */
export function BusinessLogo({ name, logoPath, className }: { name: string | null; logoPath: string | null | undefined; className: string }) {
  const url = businessLogoUrl(logoPath);
  const [failed, setFailed] = useState<string | null>(null);
  if (url && failed !== url) {
    return <img src={url} alt="" className={cx('shrink-0 bg-white object-contain', className)} onError={() => setFailed(url)} />;
  }
  return (
    <span className={cx('flex shrink-0 items-center justify-center bg-brand font-bold text-brand-fg', className)}>
      {(name ?? '?').trim().charAt(0).toUpperCase()}
    </span>
  );
}
